import React from "react";

// Route-level guard: these funnel steps require an existing checkout session.
// When the checkoutSessionID query param is missing we bounce to the patient
// portal — a DIFFERENT bundle, so this must be a full-page navigation, not a
// React Router <Redirect> (the visits router has no /me route). Rendering null
// instead of the wrapped component guarantees the component never mounts without
// the param, so its checkoutSessionID-required cookie getters can never throw.
export function withCheckoutSession(WrappedComponent) {
  return function RequireCheckoutSession(props) {
    const checkoutSessionID = new URLSearchParams(props.location.search).get(
      "checkoutSessionID",
    );
    if (!checkoutSessionID) {
      window.location.href = "/me/portal";
      return null;
    }
    return <WrappedComponent {...props} />;
  };
}
